<div class="header" fxLayout="row" fxLayoutAlign="end center">
  <div class="margin">
    <span class="material-icons close-btn pointer" id="dismiss" (click)="dismiss()">
      close
    </span>
  </div>
</div>

<div style="height: 90%;">
  <div fxLayout="column" class="content" fxLayoutGap="20px">
    <div fxLayout="column" >
      <span class="title">Versões disponíveis</span>
      <span class="subtitle">
        Escolha a versão do projeto que deseja acessar
      </span>
    </div>

    @if (data?.project?.versoes) {
      <div class="pointer" style="max-height: 90%; overflow: auto; overflow-x: hidden;">
        @for (project of data.project.versoes; track project) {
          <mat-card appearance="outlined" class="flex-container" fxLayoutGap="20px" id="inner-grid" (click)="onSelectCard(project)" [ngClass]="{'card-selected mat-elevation-z4': verificaCardSelecionado(project)} ">
            <span class="selection">
              <mat-icon>check_circle</mat-icon>
            </span>
            <!-- <div class="box"> -->
            <img class="project-pic" [src]="getImagemProjeto(project)" onError="this.src='/assets/img/img-padrao-projeto.png'" alt="Imagem {{project.descricao}}">
          <!-- </div> -->
          <div class="box">
            <span class="descProjeto">{{project.descricao}} <br/> {{project.dataAnoref}} </span>
          </div>
        </mat-card>
      }
    </div>
  }
</div>

<div style="padding: 20px;">
  @if (canDelete() && projetoSelecionado && projetoSelecionado.id > 0 && !isPublicCaller) {
    <div  [fxLayoutAlign]="'start center'" class="remover">
      <app-button [txt]="'EXCLUIR'" (click)="deletar()"
      [customStyle]="'border: 2px solid #C21E00 !important; color: #C21E00 !important; margin-right: 5px;'" fxLayoutGap="10px" > </app-button>
    </div>
  }

  <div fxLayout="row" [fxLayoutAlign]="'end center'" class="divButtons">
    <app-button [txt]="'CANCELAR'" [class]="'no-border'" (click)="dismiss()">
    </app-button>
    <app-button [txt]="'ACESSAR'" [class]="'border-blue-filled'" (click)="acessar()"> </app-button>

  </div>
</div>

</div>